import http from '@plugin/axios'

export function updateContractStatus(params: object) {
  return http({
    url: '/srmContract/updateContractStatus',
    baseURL: process.env.VUE_APP_CONTRACT_API,
    data: params
  })
}

